import styled from 'styled-components'
import { devices } from '../../utils/mediaQueries'

// eslint-disable-next-line import/prefer-default-export
export const TalentPlatformWrapper = styled.div`
  .footer {
    height: 43px;
    background-color: #3e84ff;
    width: 100%;
    position: fixed;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 100;
  }
  .nextui-navbar-container {
    background-color: #081339;
    a {
      color: #fff;
    }

    max-width: 100vw;
  }
  min-height: 100vh;
  font-family: 'Rubik', sans-serif !important;
  margin: auto;
  font-size: 15px;
  line-height: 1.6;
  font-weight: 400;
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: #0000;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeLegibility;
  background-color: #fafafa !important;
  a {
    color: black;
  }
  p {
    margin-bottom: 0;
  }

  h1 {
    font-weight: 800;
    font-size: 24px;
    display: inline-block;
    font-family: 'Rubik', sans-serif !important;
  }

  .ant-input {
    height: 50px;
    border-radius: 10px !important;
  }

  .ant-input-affix-wrapper {
    border-radius: 5px;
    padding: 0px 11px;
  }

  .ant-input-affix-wrapper .ant-input-password {
    border-radius: 5px !important;
  }

  .ant-radio-button-wrapper-checked {
    color: white !important;
  }

  .btn {
    height: 60px !important;
    display: flex;
    align-items: center;
    gap: 10px;
    position: relative;
    font-weight: 600 !important;
    font-size: 13px !important;
    padding: 1.5rem 1.5rem;
    position: relative;
    z-index: 1;
    box-shadow: 2px 3px 5px -3px rgba(0, 0, 0, 0.4);
    border: none;
    border-radius: 8px;
  }

  .secondary-btn {
    height: 40px !important;
  }

  .grey-btn {
    background-color: #f3f3f4;
    border-radius: 8px;
    border: none;
  }

  // Layer to make onboarding animation smooth
  .bg-layer {
    height: 100vh;
    width: 100vw;
    position: absolute;
    inset: 0px;
    z-index: 999;
    background-color: white;
  }

  .text-center {
    text-align: center;
  }

  .block {
    display: block !important;
  }

  .flex {
    display: flex;
  }

  .column {
    flex-direction: column;
  }

  .align-center {
    align-items: center;
  }

  .justify-center {
    justify-content: center;
  }

  .fixed {
    position: fixed;
  }

  .loading-btn {
    transition: width 0.3s cubic-bezier(0.645, 0.045, 0.355, 1),
      opacity 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  }

  .fat-line {
    display: inline-block;
    background-color: #2d50e6;
    border-radius: 100px;
    width: 30px;
    height: 10px;
  }

  .missing-resume {
    display: flex;
    align-items: center;
    opacity: 1;
    font-weight: 700;
    font-size: 13px;
    color: #ff4d4e;
    text-decoration: underline;
  }

  @media ${devices.laptop} {
    max-width: 100%;
  }
`
